import {
  QUESTIONNAIRE_SIGNIN_QUERY_PARAM_ALIAS,
  QUESTIONNAIRE_SIGNIN_QUERY_PARAM_CONTEXT,
  QUESTIONNAIRE_SIGNIN_QUERY_PARAM_LEGACY,
  buildPatientQuestionnaireSigninLink,
  normalizeQuestionnaireIdFromSigninParam,
  tryParsePatientQuestionnaireSigninPayloadFromBase64Url,
  type BuildPatientQuestionnaireSigninLinkContext,
} from "src-next/shared/patientQuestionnaireLink";

interface BuildQuestionnaireTemplateButtonUrlOptions {
  notifierContext?: BuildPatientQuestionnaireSigninLinkContext;
}

export function buildQuestionnaireTemplateButtonUrl(
  questionnaireId: string,
  options?: BuildQuestionnaireTemplateButtonUrlOptions,
): string {
  return buildPatientQuestionnaireSigninLink(questionnaireId, {
    notifierContext: options?.notifierContext,
  });
}

/**
 * Se `buttonValue` foi gerado por {@link buildQuestionnaireTemplateButtonUrl}, retorna o id.
 */
export function tryParseQuestionnaireIdFromButtonUrl(
  buttonValue: string | undefined | null,
): string | null {
  const normalized = String(buttonValue ?? "").trim();
  if (!normalized) return null;

  const fallbackToPathStyleUrl = () => {
    const matched = normalized.match(/\/questionario\/([^/?#]+)/i);
    if (!matched?.[1]) return null;
    try {
      return decodeURIComponent(matched[1]);
    } catch {
      return matched[1] || null;
    }
  };

  try {
    const parsed = new URL(normalized, window.location.origin);
    const hashQueryRaw = parsed.hash.includes("?")
      ? parsed.hash.slice(parsed.hash.indexOf("?") + 1)
      : "";
    const queryParams = new URLSearchParams(hashQueryRaw || parsed.search);

    const rawCtx = queryParams.get(QUESTIONNAIRE_SIGNIN_QUERY_PARAM_CONTEXT);
    if (rawCtx) {
      const payload = tryParsePatientQuestionnaireSigninPayloadFromBase64Url(rawCtx);
      if (payload?.questionnaireId) return payload.questionnaireId;
    }

    const rawLegacy =
      queryParams.get(QUESTIONNAIRE_SIGNIN_QUERY_PARAM_LEGACY) ??
      queryParams.get(QUESTIONNAIRE_SIGNIN_QUERY_PARAM_ALIAS);
    if (rawLegacy) {
      return normalizeQuestionnaireIdFromSigninParam(rawLegacy);
    }

    return fallbackToPathStyleUrl();
  } catch {
    return fallbackToPathStyleUrl();
  }
}
